import React from "react";
import { Link } from "react-router-dom";

import Events from "components/events";
import Stands from "components/stands";

const StandCommentsViewField = ({ stand }) => {
    return (
        <div className='view-box-field'>
            {stand?.comments_count ? (
                <Link
                    to={`${Events.Const.basePath}/${stand?.ee_id}${Stands.Const.basePath}/${stand?.id}/comments`}
                >
                    <span className='count'>{stand.comments_count}</span>
                    <span className='btn-view'>view</span>
                </Link>
            ) : (
                <strong>&mdash;</strong>
            )}
        </div>
    );
};

export default StandCommentsViewField;
